// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import md5 from 'js-md5'
import Vuex from 'vuex'
import store from './store'
import rules from './rules/index'
import 'styles/index.css'

Vue.use(Element)
Vue.config.productionTip = false
Vue.prototype.$md5 = md5
Vue.prototype.$rules = rules

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js